import { lazy } from "react";

import MainLayout from "../layout/MainLayout";
import EditEmployeePage from "../pages/ClinicManagement/Employees/EditEmployeePage";
import Accountants from "../pages/ClinicManagement/Accountants/Accountants";
import Nurses from "../pages/ClinicManagement/Nurses/Nurses";
import Assistants from "../pages/ClinicManagement/Assistants/Assistants";
import Pharmacists from "../pages/ClinicManagement/Pharmacists/Pharmacists";
import Secretaries from "../pages/ClinicManagement/Secretaries/Secretaries";
import Loadable from "../styles/ui-component/Loadable";
import EditBranchPage from "../pages/BranchManagement/EditBranchPage";
import AddBranchPage from "../pages/BranchManagement/AddBranchPage";
import RestrictedRoute from "./RestrictedRoute";
import Appointments from "../pages/MedicalOperations/Appointments/Appointments";
import AddAppointment from "../pages/MedicalOperations/Appointments/AddAppointment";
import AddPatient from "../pages/MedicalOperations/Patients/AddPatient";
import Groups from "../pages/MedicalOperations/Groups/Groups";
import PatientGroup from "../pages/MedicalOperations/Groups/PatientGroup";
import EditAppointment from "../pages/MedicalOperations/Appointments/EditAppointment/EditAppointment";
import Tests from "../pages/MedicalOperations/Tests/Tests";
import Medications from "../pages/MedicalOperations/Medications/Medications";
import Equipment from "../pages/MedicalOperations/Equipment/Equipment";
import Diagnoses from "../pages/MedicalOperations/Diagnoses/Diagnoses";
import Statistics from "../pages/MedicalOperations/Statistics/Statistics";
import InventoryTemplates from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/InventoryTemplates";
import Inventories from "../pages/MedicalOperations/Inventory-management/Inventory/Inventories";
import DeactivatedInventories from "../pages/MedicalOperations/Inventory-management/Inventory/DeactivatedInventories";
import Inventory from "../pages/MedicalOperations/Inventory-management/Inventory/Inventory";
import CreateTemplate from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/CreateTemplate";
import CreateCollection from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/CreateCollection";
import Collections from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/Collections";
import Fields from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/Fields";
import AddField from "../pages/MedicalOperations/Inventory-management/InventoryTemplate/AddField";
import AddItem from "../pages/MedicalOperations/Inventory-management/Inventory/AddItem";
import EditItem from "../pages/MedicalOperations/Inventory-management/Inventory/EditItem";
import Patient from "../pages/MedicalOperations/Patients/EditPatient/Patient";
import PatientDiagnoses from "../pages/MedicalOperations/PatientDiagnosis/PatientDiagnosis";
import PatientTreatments from "../pages/MedicalOperations/PatientTreatments/PatientTreatments";
import PatientTests from "../pages/MedicalOperations/PatientTests/PatientTests";
import PatientObservations from "../pages/MedicalOperations/Observations/PatientObservations"
import PatientArchives from "../pages/MedicalOperations/Archives/Archives";
import EditUser from "../pages/MedicalOperations/Patients/EditPatient/EditUser";
import EditPatient from "../pages/MedicalOperations/Patients/EditPatient/EditPatient";
import Observations from "../pages/MedicalOperations/Observations/Observations";
import Appointment from "../pages/MedicalOperations/Appointments/EditAppointment/Appointment";
import Branches from "../pages/BranchManagement/Branches";
import Currency from "../pages/Payment/Currency/Currency";
import Balance from "../pages/Payment/Balance/Balance";
import Bills from "../pages/Payment/Bills/Bills";
import Receipts from "../pages/Payment/Receipts/Receipts";
import PatientBills from "../pages/Payment/Bills/PatientBills/PatientBills";
import PatientReceipts from "../pages/Payment/Receipts/PatientReceipts/PatientReceipts";
import PatientBalance from "../pages/Payment/Balance/PatientBalance/PatientBalance";
import NotFound from "../layout/NotFound";
import ViewPatient from "../pages/MedicalOperations/Patients/ViewPatient";

const Calendar = Loadable(lazy(() => import("../pages/Dashboard/Calendar")));
const Admins = Loadable(lazy(() => import("../pages/ClinicManagement/Admins/Admins")));
const Doctors = Loadable(lazy(() => import("../pages/ClinicManagement/Doctors/Doctors")));
const Employees = Loadable(lazy(() => import("../pages/ClinicManagement/Employees/Employees")));
const Patients = Loadable(lazy(() => import("../pages/MedicalOperations/Patients/Patients")));

const MainRoutes = {
  path: "/",
  element: (
    <RestrictedRoute authRequirement={true}>
      <MainLayout />
    </RestrictedRoute>
  ),
  children: [
    {
      path: "",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Calendar />
        </RestrictedRoute>
      ),
    },
    {
      path: "patients",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Patients />
        </RestrictedRoute>
      ),
    },
    {
      path: "patient/add",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddPatient />
        </RestrictedRoute>
      ),
    },
    {
      path: "patient/:patientID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Patient />
        </RestrictedRoute>
      ),
      children: [
        { path: "user", element: <EditUser /> },
        { path: "info", element: <EditPatient /> },
        { path: "appointments", element: <Appointments /> },
        { path: "diagnoses", element: <PatientDiagnoses /> },
        { path: "treatments", element: <PatientTreatments /> },
        { path: "tests", element: <PatientTests /> },
        { path: "observations", element: <PatientObservations /> },
        { path: "archives", element: <PatientArchives /> },
        { path: "bills", element: <PatientBills /> },
        { path: "receipts", element: <PatientReceipts /> },        
        { path: "balance", element: <PatientBalance /> },
      ],
    },
    {
      path: "patient-view/:PatientID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <ViewPatient />
        </RestrictedRoute>
      ),
    },
    {
      path: "patient-groups",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Groups />
        </RestrictedRoute>
      ),
    },
    {
      path: "patient-groups/:GroupID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <PatientGroup />
        </RestrictedRoute>
      ),
    },
    {
      path: "appointments",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Appointments />
        </RestrictedRoute>
      ),
    },
    {
      path: "appointment/add",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddAppointment />
        </RestrictedRoute>
      ),
    },
    {
      path: "appointment/:appointmentID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Appointment />
        </RestrictedRoute>
      ),
      children: [
        { path: "info", element: <EditAppointment /> },
        { path: "observations", element: <Observations /> },
        { path: "tests", element: <PatientTests /> },
        { path: "diagnoses", element: <PatientDiagnoses /> },
        { path: "treatments", element: <PatientTreatments /> },
        { path: "bills", element: <PatientBills /> },
        { path: "receipts", element: <PatientReceipts /> },
      ],
    },
    {
      path: "add-appointment/:PatientID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddAppointment />
        </RestrictedRoute>
      ),
    },
    {
      path: "tests",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Tests />
        </RestrictedRoute>
      ),
    },
    {
      path: "medications",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Medications />
        </RestrictedRoute>
      ),
    },
    {
      path: "diagnoses",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Diagnoses />
        </RestrictedRoute>
      ),
    },
    {
      path: "statistics",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Statistics />
        </RestrictedRoute>
      ),
    },
    {
      path: "inventory-templates",
      element: (
        <RestrictedRoute authRequirement={true}>
          <InventoryTemplates />
        </RestrictedRoute>
      ),
    },
    {
      path: "inventories",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Inventories />
        </RestrictedRoute>
      ),
    },
    {
      path: "deactivated-inventories",
      element: (
        <RestrictedRoute authRequirement={true}>
          <DeactivatedInventories />
        </RestrictedRoute>
      ),
    },
    {
      path: "inventory/:InventoryID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Inventory />
        </RestrictedRoute>
      ),
    },
    {
      path: "create-template",
      element: (
        <RestrictedRoute authRequirement={true}>
          <CreateTemplate />
        </RestrictedRoute>
      ),
    },
    {
      path: "create-collection",
      element: (
        <RestrictedRoute authRequirement={true}>
          <CreateCollection />
        </RestrictedRoute>
      ),
    },
    {
      path: "add-field",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddField />
        </RestrictedRoute>
      ),
    },
    {
      path: "collections/:CollectionID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Collections />
        </RestrictedRoute>
      ),
    },
    {
      path: "fields-page/:CollectionID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Fields />
        </RestrictedRoute>
      ),
    },
    {
      path: "add-item-page/:CollectionID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddItem />
        </RestrictedRoute>
      ),
    },
    {
      path: "edit-item-page/:CollectionID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditItem />
        </RestrictedRoute>
      ),
    },
    {
      path: "equipment",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Equipment />
        </RestrictedRoute>
      ),
    },
    {
      path: "employee/add",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Employees />
        </RestrictedRoute>
      ),
    },
    {
      path: "profile/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "doctors",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Doctors />
        </RestrictedRoute>
      ),
    },
    {
      path: "doctor/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "admins",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Admins />
        </RestrictedRoute>
      ),
    },
    {
      path: "admin/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "secretaries",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Secretaries />
        </RestrictedRoute>
      ),
    },
    {
      path: "secretary/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "accountants",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Accountants />
        </RestrictedRoute>
      ),
    },
    {
      path: "accountant/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "pharmacists",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Pharmacists />
        </RestrictedRoute>
      ),
    },
    {
      path: "pharmacist/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "assistants",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Assistants />
        </RestrictedRoute>
      ),
    },
    {
      path: "assistant/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "nurses",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Nurses />
        </RestrictedRoute>
      ),
    },
    {
      path: "nurse/:employeeID/edit",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditEmployeePage />
        </RestrictedRoute>
      ),
    },
    {
      path: "branches",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Branches />
        </RestrictedRoute>
      ),
    },
    {
      path: "branch/:branchID",
      element: (
        <RestrictedRoute authRequirement={true}>
          <EditBranchPage />
        </RestrictedRoute>
      ),
    },
    {
      path: "branch/add",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddBranchPage />
        </RestrictedRoute>
      ),
    },
    {
      path: "payment",
      element: (
        <RestrictedRoute authRequirement={true}>
          <AddBranchPage />
        </RestrictedRoute>
      ),
    },
    {
      path: "payment/bills",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Bills />
        </RestrictedRoute>
      ),
    },
    {
      path: "payment/receipts",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Receipts />
        </RestrictedRoute>
      ),
    },
    {
      path: "payment/currency",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Currency />
        </RestrictedRoute>
      ),
    },
    {
      path: "payment/balance",
      element: (
        <RestrictedRoute authRequirement={true}>
          <Balance />
        </RestrictedRoute>
      ),
    },
    {
      path: "*",
      element: (
        <RestrictedRoute authRequirement={true}>
          <NotFound />
        </RestrictedRoute>
      ),
    },
  ],
};

export default MainRoutes;
